import { Route } from 'react-router';
import { ModuleGate } from '../../components/ModuleGate';
import { ContactsPage } from './ContactsPage';
import { ContactDetailPage } from './ContactDetailPage';
import { ContactFormPage } from './ContactFormPage';
import { ContactMergePage } from './ContactMergePage';
import { DuplicatesPage } from './DuplicatesPage';
import { RelationTypesPage } from './RelationTypesPage';
import type { BackofficeModule } from '../registry';

/** Bausteine, die andere Seiten des Backoffice einbinden dürfen (zum Beispiel die Anfrage) */
export { InquiryContactCreateButton, InquiryContactPanel } from './InquiryContactPanel';

/**
 * Einstiegspunkt des Moduls Kontakte im Backoffice. Alles dazu liegt in diesem Ordner. Das Backoffice kennt nur diese
 * Datei (siehe registry.ts). Die Verträge zur API stehen in packages/shared/src/contacts.
 */
export const contactsModule: BackofficeModule = {
  key: 'contacts',
  path: '/kontakte',
  // Die Beziehungsarten pflegt der Mandant in der Einrichtung (KON-104)
  setupSections: [
    {
      path: 'beziehungsarten',
      label: 'Beziehungsarten',
      module: 'setup',
      permission: 'setup.read',
      requires: 'contacts',
      description: 'In welcher Beziehung Sie zu einem Kontakt stehen, zum Beispiel Kunde, Partner, Lieferant oder Externer Dienstleister.',
      built: true,
      group: 'contacts',
      keywords: ['Kunde', 'Partner', 'Lieferant', 'Dienstleister', 'Interessent', 'Kategorie'],
    },
  ],
  setupRoutes: <Route path="beziehungsarten" element={<ModuleGate module="setup" permission="setup.read"><RelationTypesPage /></ModuleGate>} />,
  routes: (
    <>
      <Route path="kontakte" element={<ModuleGate module="contacts" permission="contacts.read"><ContactsPage /></ModuleGate>} />
      <Route path="kontakte/neu" element={<ModuleGate module="contacts" permission="contacts.write"><ContactFormPage /></ModuleGate>} />
      <Route path="kontakte/dubletten" element={<ModuleGate module="contacts" permission="contacts.read"><DuplicatesPage /></ModuleGate>} />
      <Route path="kontakte/:id/zusammenfuehren" element={<ModuleGate module="contacts" permission="contacts.write"><ContactMergePage /></ModuleGate>} />
      <Route path="kontakte/:id" element={<ModuleGate module="contacts" permission="contacts.read"><ContactDetailPage /></ModuleGate>} />
      <Route path="kontakte/:id/bearbeiten" element={<ModuleGate module="contacts" permission="contacts.write"><ContactFormPage /></ModuleGate>} />
    </>
  ),
};
